import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleAutocompleteInputComponent } from './google-autocomplete-input.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ParameterService } from '../../utils/services/parameter.service';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  providers: [ParameterService],
  declarations: [GoogleAutocompleteInputComponent],
  exports: [GoogleAutocompleteInputComponent]
})
export class GoogleAutocompleteInputModule { }



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/shared/google-autocomplete-input/google-autocomplete-input.module.ts